import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";
import * as dayjs from "dayjs";

function dateFormatter(dt: any) {
  if (dt == "Invalid Date") {
    return null;
  }
  if (dt != null) {
    return dt.toLocaleDateString("fr-CA");
  }
  return dt;
}
export default class RulesManagerService {
  private httpClient = makeHttpClient();
  getScopeData(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "scope/?" + query
      )
    );
  }
  addScopeData(formData: any, workflow: any) {
    const data = {
      country: formData.country,
      scheme: formData.scheme,
      stream: formData.stream,
      rule: formData.rule,
      valid_from: dateFormatter(formData.valid_from),
      valid_to: dateFormatter(formData.valid_to)
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<RulesManagerService>(
        env.ruleManagerUrl + "scope/null/" + workflow + "/",
        data
      )
    );
  }
  getScopeById(id: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "scope/" + `${id}/` + "view/"
      )
    );
  }

  editScopeData(formData: any, workflow: any) {
    formData.rule = formData.rule.map((a: any) => a.id);
    return _unwrapAxiosResponse(
      this.httpClient.post<RulesManagerService>(
        env.ruleManagerUrl + "scope/" + formData.id + "/" + workflow + "/",
        formData
      )
    );
  }

  getRulesData(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "rule/?" + query
      )
    );
  }

  getAllRules(stream: any = null) {
    let query_param = "";
    if (stream) {
      query_param = "?stream=" + stream;
    }

    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "rules/all" + query_param
      )
    );
  }

  getPropertyConfig() {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "property/config/"
      )
    );
  }

  getOperatorConfig() {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "operator/config/"
      )
    );
  }

  getReportDefinitionData(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "report/lists/definition/?" + query
      )
    );
  }

  getViewReportDefinitionById(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "report/definition/" + query + "/view/"
      )
    );
  }

  getOldReportDefinitionById(id: number) {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "report/definition/" + id + "/view_definition/"
      )
    );
  }

  getReportCategories(formData: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl +
          "report/categories/?" +
          "country_id=" +
          formData.country +
          "&stream_id=" +
          formData.stream +
          "&scheme_id=" +
          formData.scheme +
          "&report_type=" +
          formData.report_type +
          "&valid_from=" +
          formData.valid_from +
          "&valid_to=" +
          formData.valid_to
      )
    );
  }

  createRule(formData: any, ruleValidation: any) {
    let rule_validation = 1;
    if (ruleValidation && ruleValidation == 1) {
      rule_validation = 0;
    }
    return _unwrapAxiosResponse(
      this.httpClient.post<RulesManagerService>(
        env.ruleManagerUrl + "rule/?rule_validation=" + rule_validation,
        formData
      )
    );
  }

  getRuleById(id: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "rule/" + `${id}/`
      )
    );
  }

  editRule(id: number, formData: any) {
    return _unwrapAxiosResponse(
      this.httpClient.put<RulesManagerService>(
        env.ruleManagerUrl + "rule/" + id + "/",
        formData
      )
    );
  }

  getRulesTags() {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(env.ruleManagerUrl + "tags/")
    );
  }

  addReportDefinition(form: any, workflow: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<RulesManagerService>(
        env.ruleManagerUrl + "report/definition/null/" + workflow + "/",
        form
      )
    );
  }

  addTabularReportDefinition(form: any, workflow: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<RulesManagerService>(
        env.ruleManagerUrl + "tabular/report/definition/null/" + workflow + "/",
        form
      )
    );
  }

  editTabularReportDefinition(
    formData: any,
    workflow: any,
    forceUpdate: any = false
  ) {
    let url = "";
    if (forceUpdate) {
      url += "?force_update=true";
    }
    return _unwrapAxiosResponse(
      this.httpClient.post<RulesManagerService>(
        env.ruleManagerUrl +
          "tabular/report/definition/" +
          formData.id +
          "/" +
          workflow +
          "/" +
          url,
        formData
      )
    );
  }
  getReportDefinitionById(
    id: any,
    isViewOnly: any = false,
    isDefinitionView: any = false
  ) {
    let url = "";
    if (isDefinitionView) {
      url =
        env.ruleManagerUrl + "report/definition/" + `${id}/view_definition/`;
    } else {
      if (isViewOnly) {
        url = env.ruleManagerUrl + "report/definition/" + `${id}/view/`;
      } else {
        url = env.ruleManagerUrl + "report/definition/" + `${id}/`;
      }
    }
    return _unwrapAxiosResponse(this.httpClient.get<RulesManagerService>(url));
  }

  editReportDefinition(formData: any, workflow: any, forceUpdate: any = false) {
    let url = "";
    if (forceUpdate) {
      url += "?force_update=true";
    }
    return _unwrapAxiosResponse(
      this.httpClient.post<RulesManagerService>(
        env.ruleManagerUrl +
          "report/definition/" +
          formData.id +
          "/" +
          workflow +
          "/" +
          url,
        formData
      )
    );
  }

  getFilterScopeData(query: any) {
    let report_def_id = -1;
    if (query.id) {
      report_def_id = query.id;
    }
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl +
          "filter/scope/rules/?" +
          "country=" +
          query.country +
          "&stream=" +
          query.stream +
          "&scheme=" +
          query.scheme +
          "&report_definition_id=" +
          report_def_id +
          "&valid_to=" +
          query.valid_to +
          "&valid_from=" +
          query.valid_from
      )
    );
  }

  checkForDuplicateScope(query: any) {
    let data = "country=" + query.country;
    if (query.stream) {
      data = data + "&" + "stream=" + query.stream;
    }
    if (query.scheme) {
      data = data + "&" + "scheme=" + query.scheme;
    }
    if (query.valid_to) {
      data = data + "&" + "valid_to=" + query.valid_to;
    }
    if (query.valid_from) {
      data = data + "&" + "valid_from=" + query.valid_from;
    }
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "validate/scope/?" + data
      )
    );
  }
  deleteRule(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.delete<RulesManagerService>(
        env.ruleManagerUrl + "rule/" + query.id + "/"
      )
    );
  }

  deleteScope(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.delete<RulesManagerService>(
        env.ruleManagerUrl + "scope/" + query.id + "/"
      )
    );
  }

  deleteReportDefinition(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.delete<RulesManagerService>(
        env.ruleManagerUrl + "report/definition/" + query.id + "/"
      )
    );
  }

  updateReportDefinition(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<RulesManagerService>(
        env.ruleManagerUrl + "update/rule/definition/?" + `${query}`
      )
    );
  }

  getFilterReportDefition(
    country: any,
    scheme: any,
    stream: any,
    is_follow_up: any,
    report: any
  ) {
    let url;
    if (scheme != null && stream != null && country != null) {
      url =
        env.ruleManagerUrl +
        "validity/report/definition/" +
        "?scheme=" +
        scheme +
        "&stream=" +
        stream +
        "&country=" +
        country;
      if (report != null) {
        url = url + "&report_type=" + report;
      }
      if (is_follow_up != null) {
        url = url + "&is_follow_up=" + is_follow_up;
      }
    } else {
      url = `${env.reportingUrl}reports/`;
    }
    return _unwrapAxiosResponse(this.httpClient.get<RulesManagerService>(url));
  }
}
